import { useState } from "react";
import api, { formatApiErrorDetail } from "@/api/client";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { IDS } from "@/constants/testIds";

export default function Profilo() {
  const { user, refresh } = useAuth();
  const [emailForm, setEmailForm] = useState({ new_email: "", current_password: "" });
  const [pwForm, setPwForm] = useState({ current_password: "", new_password: "", confirm: "" });

  const changeEmail = async (e) => {
    e.preventDefault();
    if (!emailForm.new_email.trim()) return toast.error("Inserisci la nuova email");
    try {
      await api.post("/auth/change-email", emailForm);
      toast.success("Email aggiornata");
      setEmailForm({ new_email: "", current_password: "" });
      await refresh();
    } catch (err) { toast.error(formatApiErrorDetail(err?.response?.data?.detail)); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.new_password.length < 8) return toast.error("La nuova password deve avere almeno 8 caratteri");
    if (pwForm.new_password !== pwForm.confirm) return toast.error("Le nuove password non coincidono");
    try {
      await api.post("/auth/change-password", {
        current_password: pwForm.current_password,
        new_password: pwForm.new_password,
      });
      toast.success("Password aggiornata");
      setPwForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(formatApiErrorDetail(err?.response?.data?.detail)); }
  };

  return (
    <Layout>
      <div className="section-title">
        <div><h2>Profilo utente</h2><p>Gestisci le credenziali utilizzate per accedere a GymERP.</p></div>
      </div>
      <div className="account-grid">
        <div className="account-card">
          <h4><i className="fa-solid fa-envelope" /> Modifica email</h4>
          <p>La nuova email diventerà il nome utente da utilizzare al prossimo accesso.</p>
          <form onSubmit={changeEmail} data-testid={IDS.emailForm}>
            <div className="field"><label>Email attuale</label><input type="email" value={user?.email || ""} disabled /></div>
            <div className="field"><label>Nuova email</label><input type="email" value={emailForm.new_email} onChange={(e) => setEmailForm({ ...emailForm, new_email: e.target.value })} required data-testid="new-email-input" /></div>
            <div className="field"><label>Password attuale</label><input type="password" value={emailForm.current_password} onChange={(e) => setEmailForm({ ...emailForm, current_password: e.target.value })} required data-testid="email-confirm-password" /></div>
            <button className="btn primary" type="submit"><i className="fa-solid fa-envelope-circle-check" /> Aggiorna email</button>
          </form>
        </div>
        <div className="account-card">
          <h4><i className="fa-solid fa-key" /> Cambia password</h4>
          <p>Scegli una password di almeno 8 caratteri e conservala in un luogo sicuro.</p>
          <form onSubmit={changePassword} data-testid={IDS.passwordForm}>
            <div className="field"><label>Password attuale</label><input type="password" value={pwForm.current_password} onChange={(e) => setPwForm({ ...pwForm, current_password: e.target.value })} required data-testid="current-password" /></div>
            <div className="field"><label>Nuova password</label><input type="password" minLength={8} value={pwForm.new_password} onChange={(e) => setPwForm({ ...pwForm, new_password: e.target.value })} required data-testid="new-password" /></div>
            <div className="field"><label>Conferma nuova password</label><input type="password" minLength={8} value={pwForm.confirm} onChange={(e) => setPwForm({ ...pwForm, confirm: e.target.value })} required data-testid="confirm-password" /></div>
            <button className="btn primary" type="submit"><i className="fa-solid fa-key" /> Cambia password</button>
          </form>
        </div>
      </div>
      <div className="security-note">
        <i className="fa-solid fa-shield-halved" />&nbsp; La sessione utilizza JWT httpOnly con hash bcrypt lato server. Dopo 5 tentativi errati l'accesso viene bloccato per 15 minuti.
      </div>
    </Layout>
  );
}
